var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"source-data",attrs:{"href":_vm.sourceLink}},[_vm._v("\n    "+_vm._s(_vm.sourceData)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }